import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';
import Colors from '../../../../../constants/colors';

const M2 = 'm²';
const HA = 'ha';
const AreaUnits = (props) => {
    const changed = props.value && props.value !== M2;
    const shouldHighlight = changed && !props.hideHighlight;
    return (
        <div className="area-unit" data-testid="range-unit">
            <Select
                value={props.value || M2}
                sx={{
                    height: props.height,
                    color: shouldHighlight ? Colors.PRIMARY.MAIN : props.textColor,
                    backgroundColor: shouldHighlight ? Colors.ACTIVE_FILTER_BG : 'transparent',
                    '& fieldset': {
                        borderColor: changed ? Colors.PRIMARY.MAIN : props.borderColor,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: Colors.PRIMARY.MAIN,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                    },
                    fontSize: '14px',
                    'li': {
                        fontSize: '14px',
                    },
                    ...props.sx,
                }}
                onChange={props.onChange}
                variant="outlined"
                MenuProps={{ keepMounted: true, disablePortal: true }}
            >
                <MenuItem value={M2}>{M2}</MenuItem>
                <MenuItem value={HA}>{HA}</MenuItem>
            </Select>
        </div>
    );
};

AreaUnits.propTypes = {
    value: PropTypes.oneOf([M2, HA]),
    onChange: PropTypes.func,
    height: PropTypes.string,
    borderColor: PropTypes.string,
    textColor: PropTypes.string,
    hideHighlight: PropTypes.bool,
};

AreaUnits.defaultProps = {
    height: '38px',
    borderColor: Colors.BLACK_30_OPAQUE,
    textColor: Colors.BLACK_30_OPAQUE,
}

export default AreaUnits;